import { render } from "./VolTable.vue?vue&type=template&id=2d355ef0&scoped=true"
import script from "./VolTable.vue?vue&type=script&lang=js"
export * from "./VolTable.vue?vue&type=script&lang=js"

import "./VolTable.vue?vue&type=style&index=0&id=2d355ef0&lang=less&scoped=true"
import "./VolTable.vue?vue&type=style&index=1&id=2d355ef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d355ef0"]])

export default __exports__